import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { RidDictationPhysical } from '../../../../mechanics/rid-dictation-physical/rid-dictation-physical';

@Component({
  selector: 'app-dictation-physical-page',
  imports: [RidDictationPhysical],
  templateUrl: './dictation-physical-page.html',
})
export class DictationPhysicalPage {
  protected readonly $router = inject(Router);
}
